import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import AvatarInitials, { AvatarInitialsProps } from '../../../avatar-initials';

const ListItemAvatarInitials: React.FC<AvatarInitialsProps> = ({ style, ...rest }) => {
  return (
    <AvatarInitials {...rest} style={Object.assign({ marginRight: 16 }, style)} size="Xsmall" />
  );
};

export default hoistNonReactStatics(
  ListItemAvatarInitials,
  AvatarInitials,
) as typeof AvatarInitials;
